import React, { Component } from 'react';

//components
import CustomButton from "../../../../generic_components/components/buttons/CustomButton";
import HtmlTextBlock from "../../../../generic_components/components/text_display/HtmlTextBlock";

//generic functions
import {
    isEmpty
} from "../../../../functions/generic_functions";

//router
import { withRouter } from 'react-router-dom';

//import static routes
import {
    cari_app_form_url,
    cari_app_form_consent_url
}
from "../../../../router/static_routes";

//moment js
import moment from "moment";
/*
    props:
        positionData: {
            position_title=> position title
            status => position status -> "submitted"
            initial_deadline => date in the format of Month Name, day, year
            late_app_deadline => date in the format of Month Name, day, year
            qualifications => qualifications description
            duties => duties description
            about_beedie => about beedie description
            position_applicant_requirements => list of requirements
            conference => details about submission
            open_description => qualified candidate description
            onClickShowPanel => call back function to handle on click from parent
        }
        selectPositionFunc => passed in function to set the active position
        visibility => to show or not to show the position details
*/

class CariPositionPanel extends Component {

    state = {  

    }

    constructor(props) {
        super(props);

        //actions handlers
        this.handleOnClickToggleVisibilityOfContents = this.handleOnClickToggleVisibilityOfContents.bind(this);
        this.handleOnClickSetActivePositionApplication = this.handleOnClickSetActivePositionApplication.bind(this);

        //rendering ui
        this.renderPositionActionBtn = this.renderPositionActionBtn.bind(this);
        this.renderPositionTitleHeader = this.renderPositionTitleHeader.bind(this);
        this.renderPositionPanelContent = this.renderPositionPanelContent.bind(this);

        //helper functions
        this.getLinkPageNumberByPositionStatus = this.getLinkPageNumberByPositionStatus.bind(this);
        this.convertDateToReadableFormat = this.convertDateToReadableFormat.bind(this);
        this.renderDateDeadline = this.renderDateDeadline.bind(this);
    }


    //get page position number for on clicking a submitted app or continuting/creating
    getLinkPageNumberByPositionStatus() {
        //if they have submitted, return the form page for page 3 to update documents
        if (!isEmpty(this.props.positionData.application_status) && this.props.positionData.application_status.toLowerCase() === "complete") {
            return "3";
        }
        //return page 1 if its anything else
        else {
            return "1";
        }
    }

    handleOnClickSetActivePositionApplication() {

        //save position id and position title, and application data using redux to store
        if (!isEmpty(this.props.selectPositionFunc)) {

            var applicationId = null;
            var applicationStatus = null;
            if(!isEmpty(this.props.positionData.application_id)
                && !isEmpty(this.props.positionData.application_status)
            ) {
                applicationId = this.props.positionData.application_id;
                applicationStatus = this.props.positionData.application_status;
            }
            this.props.selectPositionFunc(this.props.positionData.position_id, this.props.positionData.position_title, applicationId, applicationStatus);

            //if application is has no status
            if (applicationStatus === null) {
                //redirect to the consent page of the new application
                this.props.history.push(cari_app_form_consent_url);
            }
            //application exists
            else {
                //redirect to a page using javascript with withRouter instead of navlink for single page load
                var cari_form_page = cari_app_form_url + "/" + this.getLinkPageNumberByPositionStatus();
                this.props.history.push(cari_form_page);
            }

        }
    }


    handleOnClickToggleVisibilityOfContents() {
        this.props.onClickShowPanel(this.props.positionData.position_id, !this.props.visibility);
    }

    renderPositionActionBtn() {
        //render Apply now button if positionStatus is empty
        if (isEmpty(this.props.positionData.application_status)) {
            return (
                <CustomButton
                    label={"Apply"}
                    className={"p-button-sfu-red p-action-btn cari_position_apply_btn_size pull_right"}
                    btnRaised={true}
                    btnRound={true}
                    onClickSetParentState={this.handleOnClickSetActivePositionApplication}
                />
            )
        }

        //if they have started, but not submitted, return the continue application btn
        else if (this.props.positionData.application_status.toLowerCase() === "in progress" 
            || this.props.positionData.application_status.toLowerCase() === "initial") {
            return (
                <CustomButton
                    label={"Continue Application"}
                    className={"p-button-dark-blue p-action-btn cari_position_continue_application_btn_size pull_right"}
                    btnRaised={true}
                    btnRound={true}
                    onClickSetParentState={this.handleOnClickSetActivePositionApplication}
                />
            )
        }
        //if they have submitted, return Update Documents btn
        else if (this.props.positionData.application_status.toLowerCase() === "complete") {
            return (
                <CustomButton
                    type={"button"}
                    label={"Update Documents"}
                    className={"p-button-orange p-action-btn cari_position_update_documents_btn_size pull_right"}
                    btnRaised={true}
                    btnRound={true}
                    onClickSetParentState={this.handleOnClickSetActivePositionApplication}
                />
            )
        }
    }

    renderPositionTitleHeader() {
        if(this.props.visibility) {
            return (
                <strong>
                    <span className="cari_position_title_format">
                        {this.props.positionData.position_title}
                    </span>
                </strong>
            );
        }
        else {
            return (
                <span className="cari_position_title_format"> 
                    {this.props.positionData.position_title}
                </span>
            );
        }
    }

    convertDateToReadableFormat(dateStr) {
        return moment(dateStr).format('MMMM D, YYYY');
    }

    renderDateDeadline(dateStr) {
        return (
            <React.Fragment>
                {this.convertDateToReadableFormat(dateStr) + " at 11:59 PM PST "}
            </React.Fragment>
        )
    }

    renderPositionPanelContent() {
        if (this.props.visibility) {
            return (
                <div key={this.props.positionData.position_id} className="animated fadeIn">
                    <div className="p-grid">
                        <div className="p-col-1 cari_position_panel_icon_width">
                           
                        </div>
                        <div className="p-col-11">
                         
                            <br />

                        {(!isEmpty(this.props.positionData.late_app_deadline) ?
                            <div>
                                {((this.props.positionData.currentDate > this.props.positionData.late_app_deadline) ?
                                    <div>
                                        <React.Fragment>
                                            <label className="cari_position_sub_heading late_application_text_style">
                                                The deadline for this application has passed. Any applications submitted after <strong>{this.renderDateDeadline(this.props.positionData.late_app_deadline)}</strong> will be marked as late.
                                            </label>
                                        </React.Fragment>
                                    </div>

                                :   
                                    <div>
                                        {(!isEmpty(this.props.positionData.initial_deadline) ?
                                            <React.Fragment>
                                                <label className="cari_position_sub_heading">
                                                    <strong>
                                                        Conference Deadline: &nbsp;
                                                    </strong>
                                                    {this.renderDateDeadline(this.props.positionData.initial_deadline)}
                                                </label>
                                                <br />
                                                <br />
                                            </React.Fragment>
                                        : null)}

                                        <label className="cari_position_sub_heading">
                                            <strong>
                                                Final Deadline: &nbsp;
                                            </strong> 
                                            {this.renderDateDeadline(this.props.positionData.late_app_deadline)}      
                                        </label>
                                    </div>
                                )}  
                            </div>
                        : 
                            <div>                
                                {(!isEmpty(this.props.positionData.initial_deadline) ?
                                    <React.Fragment>
                                        <label className="cari_position_sub_heading">
                                            <strong>
                                                Conference Deadline: &nbsp;
                                            </strong>
                                            {this.renderDateDeadline(this.props.positionData.initial_deadline)}
                                        </label>
                                        <br />
                                        <br />
                                    </React.Fragment>
                                : null)}

                                <label className="cari_position_sub_heading">
                                    <strong>
                                        Final Deadline: &nbsp;
                                    </strong>
                                    Open until filled
                                </label>              
                            </div>
                        )}    

                            <br />
                            <br />
                            <br/>

                            <strong className="cari_position_sub_heading">
                                Qualifications
                            </strong>
                            <div className="">
                                <HtmlTextBlock
                                    text={this.props.positionData.qualifications}
                                    className={"cari_small_text"}
                                />
                            </div>

                            <br/><br/>
                            
                            <strong className="cari_position_sub_heading">
                                Duties
                            </strong>
                            <div className="">
                                <HtmlTextBlock
                                    text={this.props.positionData.duties}
                                    className={"cari_small_text"}
                                />
                            </div>

                            <br/><br/>    

                            {(!isEmpty(this.props.positionData.about_beedie) ?
                                <React.Fragment>
                                    <strong className="cari_position_sub_heading">
                                        About the Beedie School of Business
                                    </strong>
                                    <div className="">
                                        <HtmlTextBlock
                                            text={this.props.positionData.about_beedie}
                                            className={"cari_small_text"}
                                        />
                                    </div>
                                </React.Fragment>
                                : null
                            )}

                            <br/><br/>   

                            {(!isEmpty(this.props.positionData.position_applicant_requirements)
                             && this.props.positionData.position_applicant_requirements.length < 0) ? 
                                <React.Fragment>
                                    <strong className="cari_position_sub_heading">
                                        Application Requirements
                                    </strong>
                                    <div className="">
                                        <ul className={"cari_small_text"}>
                                            {this.props.positionData.position_applicant_requirements.map(function (positionRequirement, i) {
                                                return (
                                                    <li key={i}>{positionRequirement}</li>
                                                )
                                            })}
                                        </ul>
                                    </div>
                                </React.Fragment>
                            : null}

                            
                            {(!isEmpty(this.props.positionData.conference) 
                            || !isEmpty(this.props.positionData.open_description)) ?
                                <React.Fragment>
                                    <strong className="cari_position_sub_heading">
                                        Application Details
                                    </strong>
                                    <div className="">
                                        <HtmlTextBlock
                                            text={this.props.positionData.conference}
                                            className={"cari_small_text"}
                                        />

                                        <HtmlTextBlock
                                            text={this.props.positionData.open_description}
                                            className={"cari_small_text"}
                                        />
                                    </div>
                                </React.Fragment>
                            : null}

                            <br />
                            <br />
                        </div>
                    </div>
                    <div className="p-col-12 border_bottom_style">
                        {/* border */}
                    </div>
                </div>
            )
        }
    }
    
    render() { 
        return (  
            <div>
                <div>
                    <div className="p-grid">
                        <div className="p-col-1 cari_position_panel_icon_width">
                            <span className={"center"}>
                                <CustomButton
                                    iconSize={"lg"}
                                    icon={(this.props.visibility) ? "minus" : "plus"}
                                    className={"continuing_plus_minus_button_style"}
                                    btnRaised={true}
                                    btnRound={true}
                                    onClickSetParentState={this.handleOnClickToggleVisibilityOfContents}
                                />
                            </span>
                        </div>

                        <div className="p-col-7 text_hover_cursor" onClick={this.handleOnClickToggleVisibilityOfContents}>
                            {this.renderPositionTitleHeader()}
                            &nbsp;&nbsp;
                            {(!isEmpty(this.props.positionData.application_status) && this.props.positionData.application_status.toLowerCase() === "complete") ?
                                <CustomButton
                                    label={"Submitted"}
                                    className={"p-button-success cari_position_status_btn_size"}
                                    btnRound={true}
                                    staticBtn={true}
                                />
                            : null}
                        </div>

                        <div className="p-col-2">
                            {/* empty space */}
                        </div>

                        <div className="p-col-2 positon_action_btn_padding">
                            {this.renderPositionActionBtn()}
                        </div>
                    </div>
                    {(!this.props.visibility) ?
                        <div className="p-col-12 border_bottom_style">
                            {/* border */}
                        </div>    
                    :null}    
                </div>
                <div>
                    {this.renderPositionPanelContent()}
                </div>
            </div>
        );
    }
}

export default withRouter(CariPositionPanel);